import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import salon from "../../Assets/Projects/1716206876_4ce69627-9eeb-4910-95b0-5374686b99f6.jpg";
import fitness from "../../Assets/Projects/af7d9545-5808395.jpg";
import labor from "../../Assets/Projects/1716206706_8ade339c-4b59-438a-952c-78a663862693.jpg";
import kupad from '../../Assets/Projects/kupad.png';
import hairish from '../../Assets/Projects/Screenshot-2024-03-19-at-20.33.41.png';
import dolita from '../../Assets/Projects/IMAC_FRONT_3_dolita.jpg';
import urbanExcess from '../../Assets/Projects/featured-image-5.jpg';

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.<br/>
          (Coming soon...)
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={urbanExcess}
              isBlog={false}
              title="Urban Excess"
              description="Shopify design & development for fashion store UE. Created a custom Shopify theme which looks amazing and functions to perfection. Also developed a second USD version of the site on a subdomain and developed an app to create multi-currency feeds which can be used for Google Shopping advertising."
              showLink={true}
              link="https://www.urbanexcess.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dolita}
              isBlog={false}
              title="Dolita Shoes"
              description="Shopify design & development. Customzied Bespoke theme with liquid and back-end to store user data pool into AWS DynamoDB"
              showLink={true}
              link="https://www.dolitashoes.com/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hairish}
              isBlog={false}
              title="Hairish Club"
              description="WP Theme created for a Hair Salon. Customized Elementor theme and added 14 UI/UX Guternberg blocks with React.js. Developed 2 Amdin custom plugins."
              showLink={true}
              link="https://duoclick.one/beauty-salon/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kupad}
              isBlog={false}
              title="Kupad Finance"
              description="KUPAD is a protocol built on Kucoin blockchain with the sole aim of helping projects raise capital in a decentralized way, an easy approach for both investors and project to either invest or raise funds."
              showLink={true}
              link="https://ku-pad.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fitness}
              isBlog={false}
              title="Fitness & SPA"
              description=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={labor}
              isBlog={false}
              title="Labor Part-time Job App"
              description=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={salon}
              isBlog={false}
              title="Salon App"
              description=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
